import { createContext, useContext, useReducer } from "react";
import type { PropsWithChildren } from "react";

import { filterReducer } from "~/components/blocks/filters/reducer";
import type { ResearchFilter } from "./types";

type ResearchFilterContextType = Omit<ResearchFilter, "type">;

export type ResearchFilterActions =
  | {
      type: "SET_FILTER";
      filterName: "search";
      value: ResearchFilterContextType["search"];
    }
  | {
      type: "SET_FILTER";
      filterName: "sortBy";
      value: ResearchFilterContextType["sortBy"];
    }
  | { type: "RESET_FILTER" };

const ResearchFilterContext = createContext<
  | {
      filter: ResearchFilterContextType;
      dispatch: React.Dispatch<ResearchFilterActions>;
    }
  | undefined
>(undefined);

export const ResearchFilterprovider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [filter, dispatch] = useReducer(
    filterReducer<ResearchFilterContextType>,
    {
      sortBy: "createdAtDesc",
      search: undefined,
    },
  );
  return (
    <ResearchFilterContext.Provider value={{ filter, dispatch }}>
      {children}
    </ResearchFilterContext.Provider>
  );
};

export const useResearchFilter = () => {
  const context = useContext(ResearchFilterContext);
  if (!context) {
    throw new Error(
      "useResearchFilter must be used within a ResearchFilterprovider",
    );
  }
  return context;
};
